var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
var EmailActivationModal = React.lazy(function () { return import('../../components/registration/EmailActivationModal'); });
var ThankYouModal = React.lazy(function () { return import('../../components/registration/ThankYouModal'); });
var AuthModal = React.lazy(function () { return import('../../components/auth/AuthModal'); });
var RegistrationModal = React.lazy(function () { return import('../../components/registration/RegistrationModal'); });
var SmsRecoverModal = React.lazy(function () { return import('../../components/auth/SmsRecoverModal'); });
var ForgotModal = React.lazy(function () { return import('../../components/auth/ForgotModal'); });
var RegistrationSuccessModal = React.lazy(function () { return import('../../components/registration/RegistrationSuccessModal'); });
var ModalsContainer = /** @class */ (function (_super) {
    __extends(ModalsContainer, _super);
    function ModalsContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalsContainer.prototype.render = function () {
        var _a = this.props, registrationModalToggled = _a.registrationModalToggled, emailActivationModalToggled = _a.emailActivationModalToggled, forgotModalToggled = _a.forgotModalToggled, authModalToggled = _a.authModalToggled;
        return (_jsx(Suspense, __assign({ fallback: _jsx("div", {}) }, { children: _jsxs("section", { children: [emailActivationModalToggled && _jsx(EmailActivationModal, {}), _jsx(ThankYouModal, {}), authModalToggled && _jsx(AuthModal, {}), registrationModalToggled && _jsx(RegistrationModal, {}), _jsx(SmsRecoverModal, {}), forgotModalToggled && _jsx(ForgotModal, {}), _jsx(RegistrationSuccessModal, {})] }) })));
    };
    return ModalsContainer;
}(PureComponent));
ModalsContainer.propTypes = {
    authModalToggled: PropTypes.bool.isRequired,
    forgotModalToggled: PropTypes.bool.isRequired,
    registrationModalToggled: PropTypes.bool.isRequired,
    emailActivationModalToggled: PropTypes.bool.isRequired
};
var mapStateToProps = function (state) {
    return {
        registrationModalToggled: state.registration.registrationModalToggled,
        emailActivationModalToggled: state.registration.emailActivationModalToggled,
        forgotModalToggled: state.recover.forgotModalToggled,
        authModalToggled: state.auth.authModalToggled,
    };
};
export default injectIntl(connect(mapStateToProps)(ModalsContainer));



// WEBPACK FOOTER //
// ./src/containers/app/ModalsContainer.jsx